import { render, staticRenderFns } from "./StudentFooter.vue?vue&type=template&id=53c5df22&scoped=true"
import script from "./StudentFooter.vue?vue&type=script&lang=js"
export * from "./StudentFooter.vue?vue&type=script&lang=js"
import style0 from "./StudentFooter.vue?vue&type=style&index=0&id=53c5df22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5df22",
  null
  
)

export default component.exports